import React from 'react';
import { InfoWindow } from '@vis.gl/react-google-maps';
import { mapsUrls } from './mapUtils';

/** Shares MapView's single open-popup slot so only one popup shows at a time. */
export const LOCATION_PICK_POPUP_KEY = 'picked-location';

/**
 * Popup shown where the user tapped the map. Lets them choose to search from that spot
 * ("Use this Location") instead of moving the search automatically.
 */
export default function LocationPickPopup({
  point,
  coverageAreaScores = null,
  hideSafetyScore = false,
  hideAffordabilityScore = false,
  hideLivabilityScore = false,
  onUseLocation = null,
  onClose,
}) {
  if (!point) return null;

  const { google: googleUrl, apple: appleUrl } = mapsUrls(point.lat, point.lng, null);
  const scores = coverageAreaScores || {};
  const parts = [];
  if (!hideSafetyScore && scores.safety != null) parts.push(`Safety: ${scores.safety}/10`);
  if (!hideAffordabilityScore && scores.cost != null) parts.push(`Cost: ${scores.cost}/10`);
  if (!hideLivabilityScore && scores.livability != null) parts.push(`Livability: ${scores.livability}/10`);

  return (
    <InfoWindow position={point} onClose={onClose} onCloseClick={onClose} shouldFocus={true}>
      <div className="map-view__zcta-popup">
        <div className="map-view__popup-header">
          <div className="map-view__popup-title map-view__zcta-scores">
            {parts.length ? parts.join(' · ') : 'This spot'}
          </div>
          <button type="button" className="map-view__popup-close" onClick={onClose} aria-label="Close location details">
            ×
          </button>
        </div>
        <div className="map-view__zcta-popup-actions">
          {typeof onUseLocation === 'function' && (
            <button
              type="button"
              className="map-view__zcta-popup-use-btn"
              onClick={() => {
                onUseLocation(point.lat, point.lng);
                onClose();
              }}
            >
              Use this Location
            </button>
          )}
          <a href={googleUrl} target="_blank" rel="noopener noreferrer" className="map-view__zcta-popup-link">
            Open in Google Maps
          </a>
          <a href={appleUrl} target="_blank" rel="noopener noreferrer" className="map-view__zcta-popup-link">
            Open in Apple Maps
          </a>
        </div>
      </div>
    </InfoWindow>
  );
}
